import moment from 'moment'

export const formatDate = (date) => {
    if ( typeof(date) !== 'string' ) { return "" }
    return moment(date).format('MMM D, YYYY')
}
